// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Spinner = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      stroke={stroke}
      strokeWidth='2px'
    >
      <path d='M.8,24.1C.8,11.3,11.2.9,24,.9s23.2,10.4,23.2,23.2-10.4,23.2-23.2,23.2' />
    </svg>
  );
};
